import ResultTable from '../Table/ResultTable';
import ResultHeader from '../Table/ResultHeader';
import ResultRow from '../Table/ResultRow';
import ResultHeaderCell from '../Table/ResultHeaderCell';
import HecRasHelper from '../../Helpers/HecRasHelper';
import ResultBody from '../Table/ResultBody';
import ResultBodyCell from '../Table/ResultBodyCell';

export default function BoundaryTable({ data }) {
    return (
        <ResultTable maxWidth={HecRasHelper.getWidth(40)}>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell
                        style={{
                            textAlign: 'start',
                            width: HecRasHelper.getWidth(5),
                        }}
                    >
                        Profile
                    </ResultHeaderCell>
                    <ResultHeaderCell
                        style={{
                            textAlign: 'start',
                            width: HecRasHelper.getWidth(12),
                        }}
                    >
                        Downstream BC
                    </ResultHeaderCell>
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                {data?.map((row, idx) => {
                    return (
                        <ResultRow>
                            <ResultBodyCell
                                style={{
                                    textAlign: 'start',
                                    width: HecRasHelper.getWidth(10),
                                }}
                            >
                                {row?.profile}
                            </ResultBodyCell>
                            <ResultBodyCell
                                style={{
                                    textAlign: 'start',
                                    width: HecRasHelper.getWidth(30),
                                }}
                            >
                                {row?.name} = {row?.value}
                            </ResultBodyCell>
                        </ResultRow>
                    );
                })}
            </ResultBody>
        </ResultTable>
    );
}
